import { ProductDetailDownloadType } from '@core/enums';
import brand from '@helpers/brand';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import { SearchableSelectStyles } from '@stories/Components/Forms/SearchableSelect/SearchableSelect.styles';
import { DocumentDownloadCardStyles } from '@stories/Elements/Cards/DocumentDownloadCard/DocumentDownloadCard.styles';
import styled, { css } from 'styled-components';

const Header = styled.div`
  margin-bottom: 34px;

  ${SearchableSelectStyles.Wrapper} {
    @media ${until(Device.Tablet)} {
      max-width: 100%;
      width: 100%;
    }
  }
`;

const DownloadLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  position: relative;

  @media ${until(Device.Mobile)} {
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */
    ::-webkit-scrollbar {
      display: none; /* for Chrome, Safari, and Opera */
    }
  }
`;

const DownloadCardWrapper = styled.div<{ type: ProductDetailDownloadType }>`
  ${() => DocumentDownloadCardStyles.DownloadWrapper} {
    ${({ type }) => {
      switch (type) {
        case ProductDetailDownloadType.Certificate:
        case ProductDetailDownloadType.Guide:
        case ProductDetailDownloadType.SoftwareUpdate:
        case ProductDetailDownloadType.SpareParts: {
          return css`
            border-color: ${brand.black};
          `;
        }
        case ProductDetailDownloadType.DataSheet: {
          return css`
            border-color: ${brand.grey[45]};
          `;
        }

        case ProductDetailDownloadType.FactTag: {
          return css`
            border-color: ${brand.red.base};
          `;
        }
      }
    }}
  }
`;

const SelectVariantMessage = styled.div`
  ${fonts.helvetica['97-black-condensed']}
  align-items: center;
  background-color: ${brand.red.base};
  border: none;
  border-radius: 4px;
  color: ${brand.white};
  display: flex;
  font-size: 26px;
  justify-content: center;
  min-height: 66px;
  padding: 40px 10px 30px 10px;
  text-align: center;
  text-transform: uppercase;

  @media ${until(Device.TabletLarge)} {
    font-size: 18px;
    padding: 8px 16px;
  }
`;
export const DownloadsStyles = {
  DownloadLayout,
  Header,
  SelectVariantMessage,
  DownloadCardWrapper,
};
